import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { NumberingSection } from '../../../features/settings/numbering-section'

export const Route = createFileRoute('/_app/settings/numbering')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'numbering'),
  component: NumberingSection,
})
